import React from 'react';
import '../assets/css/contactSection.css';

const ContactSection = () => {
    const contactData = [
        {
            id: 1,
            icon: "✉️",
            title: "Email us",
            type: "email",
            content: [
                ["Domestic Inquiry", "sales.india@krishnachemical-polymer.com"],
                ["Export Inquiry", "exports@krishnachemical-polymer.com"],
                ["General Inquiry", "krishnachemicalandpolymer@gmail.com"]
            ]
        },
        {
            id: 2,
            icon: "📞",
            title: "Call us",
            type: "phone",
            content: ["+91 8160995833", "+91 9979619001", "+91 9586127173"]
        },
        {
            id: 3,
            icon: "📍",
            title: "Our Location",
            content: "PLOT NO 1644, ROAD NO 16 G.I.D.C. SARIGAM STATION BHILAD. DIST.VASAD - 396155",
        },
        {
            id: 4,
            icon: "🕒",
            title: "Working Hours",
            content: (
                <div className="hours-grid">
                    <span>Mon-Sat:</span> <span>24 Hours</span>
                    <span>Sunday:</span> <span>Closed</span>
                </div>
            ),
        }
    ];

    return (
        <section className="contact-container">
            <div className="contact-header">
                <span className="subtitle">CONTACT US</span>
                <h1>Contact Us Today</h1>
            </div>

            <div className="contact-grid">
                {contactData.map((item) => (
                    <div key={item.id} className="contact-card">
                        <div className="icon-wrapper">{item.icon}</div>
                        <h3>{item.title}</h3>
                        {item.type === "email" ? (
                            <div className="contact-text contact-list">
                                {item.content.map(([label, email]) => (
                                    <div className="contact-list-item" key={email}>
                                        <span className="contact-label">{label}</span>
                                        <a href={`mailto:${email}`} className="contact-link">{email}</a>
                                    </div>
                                ))}
                            </div>
                        ) : item.type === "phone" ? (
                            <div className="contact-text contact-list">
                                {item.content.map((phone) => (
                                    <a
                                        href={`tel:${phone.replace(/\D/g, '')}`}
                                        className="contact-link"
                                        key={phone}
                                    >
                                        {phone}
                                    </a>
                                ))}
                            </div>
                        ) : (
                            <div className="contact-text">{item.content}</div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default ContactSection;